import { render, staticRenderFns } from "./BaseDatePicker.vue?vue&type=template&id=2bf5e071"
import script from "./BaseDatePicker.vue?vue&type=script&lang=js"
export * from "./BaseDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports